import { defineStore } from 'pinia';
import { AppConfigType, LanguageType, LimitDataType, SystemDataType, ServiceListType } from 'types/appConfig';
import sysConfig from 'service/sysConfig';
import user from 'service/user';
import HiCache from 'utils/cache';
import dayjs from 'dayjs';
import { getTheme } from 'web_v2/src/styles/theme';

export const useAppStore = defineStore({
    id: 'appStore',
    state: () => {
        return {
            appName: 'App Name',
            language: '',
            languageList: [],
            appConfig: null,
            getOffsetWidth: 0,
            systemData: {} as SystemDataType,
            limitData: {} as LimitDataType,

            globalLoading: true,
            isApp: false,

            i18nProp: null,
            serviceList: [],
            getService: '',
            metaTitle: '',
            openSider: true,
            isShowHeaderTop: true,
            isFirst: false,
            noticeListData: [],
            showHongbao: true,
            pwaTempConfig: {},
            pwaConfig: {},

            // 是否关闭顶部
            isCloseHeaderTop: false,

            // 全局apk
            globalApkDownloadUrl: '',

            // 指纹
            fingerprintId: '',
        };
    },
    getters: {
        getSystemData: state => state.systemData,
        GetLimitData: state => state.limitData,
        GetOffsetWidth: state => state.getOffsetWidth,
        GetGlobalLoading: state => state.globalLoading,
        GetLanguageList: state => state.languageList,
        getIsApp: state => state.isApp,
        ServiceList: state => state.serviceList,
        GetService: state => state.getService,
        GetIsShowHeaderTop: state => state.isShowHeaderTop,
        GetIsFirst: state => state.isFirst,
        GetNoticeListData: state => state.noticeListData,
        GetShowHongbao: state => state.showHongbao,
        GetPwaTempConfig: state => state.pwaTempConfig,
        GetPwaConfig: state => state.pwaConfig,
        GetIsCloseHeaderTop: state => state.isCloseHeaderTop,
        GetGlobalApkDownloadUrl: state => state.globalApkDownloadUrl,
        GetFingerprintId: state => state.fingerprintId,
    },
    actions: {
        setShowHongbao(data: boolean) {
            this.showHongbao = data;
        },
        setPwaTempConfig(data: any) {
            this.pwaTempConfig = data;
        },
        async handleGetNoticeList() {
            if (this.noticeListData.length > 0) return;
            // getWithdrawOrderList
            // const result = await sysConfig.getWithdrawOrderList({ rows: 20 });
            const result = await sysConfig.getScrollNoticeList({ rows: 100 });
            const { code, data } = result;
            console.log(data, 'data');
            
            if (code === 0) {
                if(data.scrollWithdrawList.length > 0){
                    this.noticeListData = data.scrollWithdrawList;
                } else {
                    this.noticeListData = data.scrollNoticeList;
                }
            }
            return result;
        },

        async handleGetLanguage(language?: string) {
            const result = await user.getFrontLanguages();
            const { code, data: i18nData } = result;
            this.languageList = i18nData || [];
            if (language) {
                return (this.language = language);
            }

            if (code === 0 && Array.isArray(i18nData) && i18nData.length > 0) {
                // this.language = (i18nData[0] as LanguageType).value;
                const lang = HiCache.getCache('language');
                if (lang) {
                    // 判断lang是否在i18nData中
                    const isLang = i18nData.some(item => item.value === lang);
                    if (isLang) {
                        this.language = lang;
                    } else {
                        // 取isDefault为true的语言
                        const defaultLang = i18nData.find(item => item.isDefault);
                        this.language = defaultLang?.value || 'en';
                    }
                } else {
                    // 取isDefault为true的语言
                    const defaultLang = i18nData.find(item => item.isDefault);
                    this.language = defaultLang?.value || 'en';
                }
            } else {
                // data.SET_LANGUAGE(i18nData.value);
                this.language = 'en';
            }
        },
        // 设置多语言
        setLanguage(value: string) {
            this.language = value;
            HiCache.setCache('language', value);
            location.reload();
        },
        setIsFirst(value: boolean) {
            this.isFirst = value;
        },
        // 清除缓存数据
        removeSession() {
            HiCache.deleteCache('GameVersionKey');
            HiCache.deleteCache('getConfigVersion');
            localStorage.removeItem('gameLotteryList');
            localStorage.removeItem('gameTypeList');
            localStorage.removeItem('topClickList');
            localStorage.removeItem('systemData');
        },
        // 获取系统配置
        async handleGetSystemData(lang: string) {
            try {
                const res = await sysConfig.getConfigVersion();
                const getVersion = HiCache.getCache('getConfigVersion');

                const theme = getTheme();
                const version = lang + '_' + res?.data + '_' + theme;
                if (version === getVersion) {
                    // console.log('版本号相同');
                    this.systemData = localStorage.getItem('systemData') && JSON.parse(localStorage.getItem('systemData') as string);
                    this.getService = this.systemData?.customerLink;
                    if (this.systemData) return this.systemData;
                }

                try {
                    const result = await sysConfig.getSysConfig();
                    if (result.code === 0) {
                        const { data } = result;
                        //返回数据统一处理
                        if (data.isUseAppUrl) data.isUseAppUrl = Boolean(data.isUseAppUrl);
                        if (data.isOpenNewCustomer) data.isOpenNewCustomer = Boolean(parseInt(data.isOpenNewCustomer));
                        if (data.isOpenChristmasSkin) data.isOpenChristmasSkin = Boolean(parseInt(data.isOpenChristmasSkin));
                        if (data.isUseAndroidAppUrl) data.isUseAndroidAppUrl = Boolean(data.isUseAndroidAppUrl);
                        if (data.pop_time) data.pop_time = parseInt(data.pop_time);
                        if (data.isRechargeBindBankCard) data.isRechargeBindBankCard = Boolean(parseInt(data.isRechargeBindBankCard));
                        if (data.isPollingPayBank) data.isPollingPayBank = Boolean(parseInt(data.isPollingPayBank));
                        if (data.isOpenPromoPreferential) data.isOpenPromoPreferential = Boolean(parseInt(data.isOpenPromoPreferential));
                        if (data.agentMoneyToMoney) data.agentMoneyToMoney = Boolean(parseInt(data.agentMoneyToMoney));
                        if (data.isShowPreferentialTask) data.isShowPreferentialTask = Number(data.isShowPreferentialTask) === 1;
                        if (data.isShowSuperJackpot) data.isShowSuperJackpot = Number(data.isShowSuperJackpot) === 1;
                        if (data.isShowWashCode) data.isShowWashCode = Number(data.isShowWashCode) === 1;

                        this.systemData = data;
                        this.getService = data?.customerLink;
                        HiCache.setCache('getConfigVersion', version);
                        localStorage.setItem('systemData', JSON.stringify(this.systemData));
                        return version;
                    }
                } catch (e) {
                    // console.log('获取配置报错', e);
                    await Promise.reject(e);
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 获取注册限制信息
        async handleGetRegIsShow(channel: string) {
            try {
                const result = await sysConfig.getRegIsShow({ page: 1, rows: 20, channel });
                if (result && result.code === 0) {
                    this.limitData = result.data;
                }
                return result;
            } catch (e) {}
        },
        setOffsetWidth(data: number) {
            this.getOffsetWidth = data;
        },
        // 获取游戏缓存
        async getGameVersion() {
            try {
                const result = await sysConfig.getGameVersion();
                if (result && result.code === 0) {
                    return result.data;
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 设置globalLoading
        setGlobalLoading(data: boolean) {
            this.globalLoading = data;
        },

        setIsApp(data: boolean) {
            // console.log('当前是否是App: ', data);
            this.isApp = data;
        },

        // 侧边菜单客服接口
        async handleGetFindPromoEnabled() {
            try {
                const result = await sysConfig.getFindPromoEnabled();
                // console.log(result, '123456');

                if (result?.code === 0) {
                    this.serviceList = result.data;
                    if (Array.isArray(result?.data) && result?.data?.length > 0) {
                        const newObj = result?.data?.find(item => item?.username === 'telegram');
                        // console.log(newObj);
                        this.getService = newObj?.link;
                    }
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },

        // 最顶部是否显示
        setIsShowHeaderTop(status: boolean) {
            this.isShowHeaderTop = status;
        },

        // 获取轮盘 根据sn获取轮盘
        async findUserRoulette(data: any) {
            try {
                return await sysConfig.findUserRoulette(data);
            } catch (e) {
                return Promise.reject(e);
            }
        },

        // 获取轮盘提现记录
        async rouletteWithdraw(data: any) {
            try {
                return await sysConfig.rouletteWithdraw(data);
            } catch (e) {
                return Promise.reject(e);
            }
        },

        // 旋转轮盘
        async rouletteUserDraw(data: any) {
            try {
                return await sysConfig.rouletteUserDraw(data);
            } catch (e) {
                return Promise.reject(e);
            }
        },

        // 获取轮盘提现记录
        async findUserRouletteRecord(data: any) {
            try {
                return await sysConfig.findUserRouletteRecord(data);
            } catch (e) {
                return Promise.reject(e);
            }
        },

        // 获取轮盘详情提现记录
        async findUserRouletteMemberFlow(data: any) {
            try {
                return await sysConfig.findUserRouletteMemberFlow(data);
            } catch (e) {
                return Promise.reject(e);
            }
        },

        async handleGetPromotionTemplate(data: any) {
            try {
                try {
                    return await sysConfig.getPromotionTemplate(data);
                } catch (e) {
                    // console.log('获取配置报错', e);
                    await Promise.reject(e);
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },

        setPwaConfig(data: any) {
            this.pwaConfig = data;
        },

        setIsCloseHeaderTop(data: boolean) {
            this.isCloseHeaderTop = data;
        },

        // 根据渠道获取安卓apk下载地址
        async getPromotionTemplateChannel(data: any) {
            try {
                const result = await sysConfig.getPromotionTemplateChannel(data);
                const { data: resData } = result;
                if (resData) {
                    const t = Date.now();
                    this.globalApkDownloadUrl =  resData + (resData.includes('?') ? '&' : '?') + 't=' + t;
                }
            } catch (e) {
                return Promise.reject(e);
            }
        },

        setFingerprintId(data: string) {
            this.fingerprintId = data;
        },

        // 切换语言
        async handleSwitchLanguage(data: any) {
            try {
                const result = await sysConfig.switchLanguage(data);
                return result;
            } catch (e) {
                return Promise.reject(e);
            }
        },
    },
});
